import React from 'react';

import PaymentTerm from 'components/Tvendo/BusinessPartner/DataMaster/PaymentTerm/List.js';

export default function () {
  return <PaymentTerm />;
}
